
/**
 * 防范xss攻击
 */
	export default ( partten ) => {
		if(typeof partten !== "string") return partten ;
		return partten.replace(/\<([\s\S]*)(script|alert)([\s\S]*)\>/ , '') ;
	}